import React from 'react';
import '../styles/ClientLogos.css'; 

const fullClientData = [
  { name: "INDO COUNT INDUSTRIES LTD", logo: "/newlyaddedclients/indocount.png" },
  { name: "THE SUPREME INDUSTRIES LTD", logo: "/newlyaddedclients/supreme.png" },
  { name: "SUZLON ENERGY LTD. PANCHAL", logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD. CHADVEL NANDURBAR", logo: "/clients/Suzlon-3.png" },
  { name: "NELSON GLOBAL INDIA LTD.", logo: "/clients/Nelson-Global-1.png" },
  { name: "PRESICE CHEMI PHARMA LTD.", logo: "/clients/Precise-chemi-2.png" },
  { name: "SUZLON ENERGY LTD.", logo: "/clients/Suzlon-3.png" }, 
  { name: "EVEREST INDIA INDUSTRIES PVT. LTD.", logo: "/clients/Everest-industries-4.png" },
  { name: "Zobele India PVT. LTD.", logo: "/clients/Zobele-7.png" },
  { name: "MENON AND MENON LTD.", logo: "/clients/Menon-and-menon-8.png" },
  { name: "KIRLOSKAR BROTHERS LTD.", logo: "/clients/Kirloskar-brothers-9.png" },
  { name: "ROCK WOOL INDIA LTD.", logo: "/clients/rockwool-11.png" },
  { name: "POLYCAB WIRES PVT LTD.", logo: "/clients/polycab-wires-13.png" },
  { name: "EBIXCASH GLOBAL SERVICES PVT LTD.", logo: "/clients/ebix-cash-global-14.png" },
];

const uniqueClientLogos = Array.from(new Map(fullClientData.map(client => [client.logo, client])).values());

function ClientLogos() {
  return (
    <section className="client-logos__section">
      <div className="client-logos__container">
        <p className="client-logos__greeting">OUR VALUED PARTNERS</p>
        <h2 className="client-logos__title">
          Trusted By India's Leading Industrial Names
        </h2>
        <div className="client-logos__grid">
          {uniqueClientLogos.map((client, index) => (
            <div key={index} className="client-logos__item">
              <img 
                src={client.logo} 
                alt={`${client.name} logo`} 
                className="client-logos__img"
                title={`${client.name} logo`} 
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientLogos;